import React from 'react';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
export function Hero() {
  return <Section className="py-20 md:py-32" background="offwhite" data-id="element-99">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-100">
        <div data-id="element-101">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-primary-deep-blue mb-6" data-id="element-102">
            Bringing Essential Medical Care to Egypt's Ancient Monasteries
          </h1>
          <p className="text-lg md:text-xl font-inter text-neutral-charcoal mb-8" data-id="element-103">
            We're preparing our inaugural shipment of medical supplies to serve
            monastery communities preserving faith and culture for nearly 2,000
            years.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-104">
            <Button href="https://www.paypal.com/donate/?hosted_button_id=555JFTK9EZ7LU" size="lg" data-id="element-105">
              Donate Now
            </Button>
            <Button href="/how-it-works" variant="secondary" size="lg" data-id="element-106">
              How It Works
            </Button>
          </div>
        </div>
        <div className="relative" data-id="element-107">
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-108">
            <img src="https://images.unsplash.com/photo-1584515933487-779824d29309?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Medical supplies being prepared for shipping" className="w-full h-full object-cover" data-id="element-109" />
          </div>
        </div>
      </div>
    </Section>;
}